import { ReactNode } from "react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { ArrowLeft } from "lucide-react"
import { useNavigate } from "react-router-dom"

interface AdminPageContainerProps {
  title: string
  subtitle?: string
  children: ReactNode
  actions?: ReactNode
  showBackButton?: boolean
  backTo?: string
  className?: string
}

/**
 * Container padrão para páginas administrativas
 */
export function AdminPageContainer({
  title,
  subtitle,
  children,
  actions,
  showBackButton = false,
  backTo,
  className,
}: AdminPageContainerProps) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (backTo) {
      navigate(backTo)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={cn("space-y-6", className)}>
      {/* Header */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <Button variant="ghost" size="sm" onClick={handleBack} className="h-8 w-8 p-0">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          )}

          <div>
            <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
            {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
          </div>
        </div>

        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {/* Content */}
      <div className="space-y-6">{children}</div>
    </div>
  )
}
